import { useNavigate } from "react-router-dom";
import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import Modal from "../../../components/portal/Modal";
import HeadingDialog from "../../../components/UI/viewDialogs/HeadingDialog";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";
import { timeStampToDateAndTime } from "../../../functions/dateTime/timeStampToDateAndTime";
import GetCheckCross from "../../../components/UI/viewDialogs/GetCheckCross";
import { checkValue } from "../../../functions/checkValue";
import successIcon from "../../../assets/icons/successIcon.svg";

export default function MachineViewDialog({
  closeDialog,
  viewDetails,
  successView,
}) {
  const navigate = useNavigate();
  return (
    <Modal
      onClose={successView ? undefined : closeDialog}
      closeIcon={!successView}
      modalWidth="view-dialog-content"
    >
      {!successView && <HeadingDialog heading="Machine Details" />}
      {successView && (
        <>
          <img
            src={successIcon}
            alt="messageIcon"
            className="mx-auto mb-1 w-9"
          />
          <p className="view-success-msg-d">Machine Successfully Added!</p>
        </>
      )}
      <div
        className={`${successView ? "max-h-500" : "max-h-600"} overflow-auto`}
      >
        <h4 className="machineInfo-view--d">Machine Info</h4>
        <div className="view-dialog-content-wrap">
          <DetailRow title="Machine ID" value={viewDetails.id} />
          <DetailRow title="Category" value={viewDetails.category.name} />
          <DetailRow
            title="Assigned Site Name"
            value={checkValue(viewDetails.station?.name)}
          />
          <DetailRow
            title="Assigned Site ID"
            value={checkValue(viewDetails.station?.id)}
          />
          <DetailRow
            title="Assigned"
            value={<GetCheckCross checkVal={viewDetails.isAssigned} />}
          />
          <DetailRow
            title="JN Field Technician"
            value={checkValue(viewDetails.station?.jnFieldTechnician?.fullName)}
          />
          <DetailRow
            title="JN Supervisor"
            value={checkValue(
              viewDetails.station?.jnFieldTechnician?.jnSupervisor?.fullName,
            )}
          />
          <DetailRow
            title="Created By"
            value={viewDetails.createdBy.fullName}
          />
          <DetailRow
            title="Created At"
            value={timeStampToDateAndTime(viewDetails.createdAt)}
          />
          <DetailRow
            title="Updated By"
            value={viewDetails.updatedBy.fullName}
          />
          <DetailRow
            title="Updated At"
            value={timeStampToDateAndTime(viewDetails.updatedAt)}
          />
        </div>
        {viewDetails.state && (
          <>
            <h4 className="machineState-view--d">Machine State</h4>
            <div className="p-4 rounded-md 3xl border-1 border-lg5 shadow-md">
              <DetailRow
                title="Sampling Time"
                value={checkValue(viewDetails.state?.controlFlags)}
              />
              <DetailRow
                title="Last Day Flags"
                value={checkValue(viewDetails.state?.statusFlags)}
              />
              <DetailRow
                title="Sampling Time"
                value={checkValue(viewDetails.state?.samplingTime)}
              />
              <DetailRow
                title="Last Day Flags"
                value={checkValue(viewDetails.state?.lastDayFlags)}
              />
              <DetailRow
                title="Analyzer Status"
                value={checkValue(viewDetails.state?.analyzerStatus)}
              />
              <DetailRow
                title="Shutoff Status"
                value={checkValue(viewDetails.state?.shutoffStatus)}
              />
              <DetailRow
                title="Error Count"
                value={checkValue(viewDetails.state?.errorCount)}
              />
              <DetailRow
                title="Created At"
                value={timeStampToDateAndTime(viewDetails.state?.createdAt)}
              />
              <DetailRow
                title="Updated At"
                value={timeStampToDateAndTime(viewDetails.state?.updatedAt)}
              />
            </div>
          </>
        )}
      </div>
      {successView && (
        <div className="pt-5 text-center">
          <GradientButton
            btnText="Ok"
            width="w-28"
            onClick={() => navigate("/site/all-machine")}
          />
        </div>
      )}
    </Modal>
  );
}
